var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgCreateMediaIcon(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M44.249 3.11l2.875 8.22v.725c-.24.242-.24.484-.479.726L11.301 24.868h37.5c.48 0 1.199.484 1.199 1.21v21.274c0 2.418-1.917 4.352-4.553 4.352H7.586c-2.396 0-4.553-1.934-4.553-4.352V26.32L.157 17.858c-.24-.967-.24-2.176.24-3.143.48-.967 1.438-1.934 2.396-2.176L38.737.209c2.157-.725 4.793.484 5.512 2.901zm3.834 23.935H5.19v20.307c0 1.21.958 2.176 2.396 2.176h38.1c1.199 0 2.397-.967 2.397-2.176V27.045zm-21.806 15.23v2.176h-12.94v-2.176h12.94zm13.419-5.077v2.176h-26.36v-2.176h26.36zm0-5.077v2.176h-26.36v-2.176h26.36zM5.8 13.528l-2.048.703c-.72.484-.959.725-1.198 1.209-.24.484-.24 1.209 0 1.692l2.48 6.826.766-10.43zm6.732-2.309l-4.518 1.55-.788 10.919 4.72-1.616.586-10.853zm6.715-2.303l-4.516 1.549-.802 10.928 4.72-1.616.598-10.861zm6.676-2.291l-4.464 1.532-.598 10.863 4.274-1.463.788-10.932zm6.716-2.303l-4.477 1.536-.599 10.868 4.273-1.463.803-10.941zm6.704-2.3l-4.49 1.541-.789 10.938 4.489-1.537.79-10.942zm2.166.1l-.742 10.084 4.68-1.601-2.636-7.253c-.292-.59-.762-1-1.302-1.23z",
    fill: `url(#${_id})`
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.66%",
    y1: "7.565%",
    x2: "24.377%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC54BE",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5802D5",
    offset: "100%"
  })))));
}
export default SvgCreateMediaIcon;